<script setup lang="ts">
import DraggableCard from '@/components/Cards/DraggableCard.vue'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import { BaseCard, StackLayout, TitleTypography } from '@rfc/rfc-components-library'
import { type Position } from '@vueuse/core'
import { ref, type Ref } from 'vue'
import type { FFDragEvent } from '../../../../../types/Firefox/DragEvent'

type Props = {
    data: CheckpointModel
}
defineProps<Props>()

defineEmits<{
    (e: 'dragStart', data: CheckpointModel, event: FFDragEvent | TouchEvent): void
    (e: 'dragEnd', position?: Position, event?: FFDragEvent | TouchEvent): void
    (e: 'drag', position?: Position): void
}>()

const draggableRef = ref<Ref<{ handle: Ref<HTMLDivElement> }> | null>(null)

defineExpose({ ref: draggableRef })
</script>

<template>
    <DraggableCard
        ref="draggableRef"
        @drag="$emit('drag', $event)"
        @dragStart="$emit('dragStart', data, $event)"
        @dragEnd="(val1, val2) => $emit('dragEnd', val1, val2)"
        setDragPosition>
        <BaseCard class="flex checkpoint-card pointer">
            <template #header>
                <StackLayout class="header-checkpoint-card align-items-center space-between">
                    <TitleTypography :title="data?.name" class="actual-text" />
                </StackLayout>
            </template>
        </BaseCard>
    </DraggableCard>
</template>
